import { render, staticRenderFns } from "./customerStories.vue?vue&type=template&id=d5610148&scoped=true&"
import script from "./customerStories.vue?vue&type=script&lang=js&"
export * from "./customerStories.vue?vue&type=script&lang=js&"
import style0 from "./customerStories.vue?vue&type=style&index=0&id=d5610148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5610148",
  null
  
)

export default component.exports